import { ProfileCompletionStepDefinition } from './ProfileCompletionStep';

export enum ProfileCompletionFlowStep {
    APPLICATION_ACCEPTED = 'APPLICATION_ACCEPTED',
    PERSONAL_INFO_FORM = 'PERSONAL_INFO_FORM',
    EDUCATION_INFO_FORM = 'EDUCATION_INFO_FORM',
    FINANCING_INFO_FORM = 'FINANCING_INFO_FORM',
    SIGN_AGREEMENT = 'SIGN_AGREEMENT',
}

export type ProfileCompletionFlowState = {
    currentStep: ProfileCompletionStepDefinition | null;
    getStep: (step: ProfileCompletionFlowStep) => ProfileCompletionStepDefinition;
    navigateNext: () => void;
    navigatePrevious: () => void;
    navigateTo: (step: ProfileCompletionFlowStep) => void;
    reset: () => void;
    stepsList: ProfileCompletionStepDefinition[];
};
